// extracted by mini-css-extract-plugin
export default {"rawMessage":"LogMessage_rawMessage__RXwmz","error":"LogMessage_error__cxOGe"};